module.exports = __webpack_public_path__ + "assets/images/3a6803d5f7806c515090e1747e336394.png";